import {SlackWebhookError, SlackWebookSubscription, SubscriptionType} from './types';

export function validateSlackWebhook(subscription: SlackWebookSubscription): SlackWebhookError {
  if (subscription.type !== SubscriptionType.SlackWebhook) {
    throw Error(`Incorrect subscription type`);
  }

  let error = null;
  if (!subscription.data.slack_webhook_url.startsWith(`https://hooks.slack.com/services/`)) {
    error = SlackWebhookError.InvalidUrl;
  }
  return error;
}
